import __C from '../../../../../../includes/primitives/_constant_'

export default {
    Canvas: {
      CanvasWidth: 260,
      CanvasHeight: 70,
      CanvasBorderWeight: 0.1,
      CanvasBorderColor: '#bcbcbc',
      CanvasFillColor: 'Transparent',
      CanvasOpacity: 0.2,

      CanvasChartX: 0,
      CanvasChartY: 0,
      CanvasChartWidth: 260,
      CanvasChartHeight: 310,
      CanvasChartBorderWeight: 0,
      CanvasChartBorderColor: '#757575',
      CanvasChartFillColor: '#757575',
      CanvasChartOpacity: 0,
      CanvasChartSpace: 0,

      CanvasFontFamily: 'roboto',
    },
    Text: {
      Text: [], 
      Filter: [],
      Sql: []
    },
    DataItems:  [
      {INDIRECT_PLAN:2443,INDIRECT_ACTUAL:4423,DIRECT_PLAN:1490,DIRECT_ACTUAL:1419,INDIRECT_DELTA:2440,DIRECT_DELTA:-4471}
    
    ],
}